import * as React from "react";
import type { AppIconProps } from "./AppIcon.types";
import { useAppIcon } from "./useAppIcon";
import { useAppIconStyles } from "./useAppIconStyles.styles";
import { renderAppIcon } from "./renderAppIcon";
import { useV9AppIconEnabled } from "../../hooks/useAppIconExperiments";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { Icon } from "@fluentui/react";

/**
 * Icon component that can be targeted by customizations.
 * Customization refers to usage of "registerIcon" to register a custom font or svg
 * To style the icon, use `className`.
 * {@docCategory Icon}
 */
export const AppIcon = React.memo(
  React.forwardRef<HTMLElement, AppIconProps>((props, ref) => {
    const state = useAppIcon(props, ref);
    useAppIconStyles(state);
    return renderAppIcon(state);
  })
);

AppIcon.displayName = "AppIcon";

export const AppIconFlight = React.memo(
  React.forwardRef<HTMLElement, AppIconProps>((props, ref) => {
    const isV9IconEnabled = useV9AppIconEnabled();
    return isV9IconEnabled ? (
      <AppIcon {...props} ref={ref} />
    ) : (
      <Icon {...props} />
    );
  })
);
